import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/features/auth';
import { TouchService } from '@app/core/services/touch/touch.service';
import { Globals } from '@app/shared/models';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  isLoad: boolean;

  constructor(
    private authService: AuthService,
    public globals: Globals,
    // this service is in-use by template, please do not remove
    public touchService: TouchService
  ) {}

  ngOnInit() {}

  onClick(event?) {
    if (event) {
      event.preventDefault();
    }

    this.authService.loginRedirect();
  }
}
